<template>
  <div>
    <NavBar transparent>
      <template #left>
        <IconButton
          type="button"
          icon-name="ic_cancel"
          @click="goToPreviousStep"
        />
      </template>
    </NavBar>
    <div class="content">
      <HelperView
        class="helper-view"
        title="Dispositivos desconectados"
        description="Se ainda precisar de ajuda, envie um e-mail para meajuda@warren.com.br"
        icon="ic_check_simple"
        type="positive"
      />
    </div>
    <Footer>
      <div>
        <ButtonPrimary
          label="Voltar para o login "
          size="large"
          @click="goLogin"
        />
      </div>
    </Footer>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Vue } from 'vue-property-decorator';
import {
  NavBar,
  IconButton,
  ButtonPrimary,
  Footer,
  HelperView
} from '@warrenbrasil/nebraska-web';
import * as trackEvents from './track-events';

@Component({
  components: {
    NavBar,
    IconButton,
    ButtonPrimary,
    Footer,
    HelperView
  }
})
export default class DisconnectDevicesFeedback extends Vue {
  @Emit('previous-step')
  public goToPreviousStep() {
    trackEvents.trackCloseClick();
  }

  public goLogin() {
    trackEvents.trackBackToLogin();
    this.$router.back();
  }

  mounted() {
    trackEvents.trackDisconnectDevicesFeedbackLoad();
  }
}
</script>
<style lang="less" scoped>
.content {
  @navbar-height: 64px;
  @footer-height: 150px;
  min-height: calc(100vh - (@navbar-height + @footer-height));
  display: flex;
  justify-content: center;
  align-items: center;

  .helper-view {
    width: 320px;
  }
}
</style>
